import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpService } from '../service/http.service';
import { SchoolContact } from '../school-contact';
import { SchoolService } from '../service/school.service';
import { ToastMessageService } from '../toast-message.service';

@Component({
  selector: 'app-school-contact-edit',
  templateUrl: './school-contact-edit.component.html',
  styleUrls: ['./school-contact-edit.component.css']
})
export class SchoolContactEditComponent implements OnInit {

  contactForms: FormGroup[] = [];
  contacts: SchoolContact[] = [];
  loadingContacts = false;
  contactCreatingForm!: FormGroup;
  sendingRequest = false;

  constructor(
    public schoolService: SchoolService,
    private httpService: HttpService,
    private builder: FormBuilder,
    private toastService: ToastMessageService
  ) { }

  ngOnInit(): void {
    this.loadingContacts = true;
    this.httpService.getSchoolContacts(this.schoolService.selectedSchoolId).subscribe(res => {
      this.loadingContacts = false;
      this.contacts = res;
      this.makeContactEditForms();
    });
    this.httpService.getSchoolContactTypes().subscribe(res => {
      this.schoolService.schoolContactTypes = res;
    });
  }

  makeContactEditForms() {
    for (let contact of this.contacts) {
      let contactForm = this.builder.group({
        contactType: [contact.schoolContactType, Validators.required],
        name: [contact.name, Validators.required],
        email: contact.email,
        phoneNumber: contact.phoneNumber,
        id: contact.id
      });
      this.contactForms.push(contactForm);
      if (this.schoolService.selectedSchool.isDeleted) {
        contactForm.disable();
      }
    }
  }

  addContactForm() {
    this.contactForms.push(
      this.builder.group({
        contactType: [null, Validators.required],
        name: [null, Validators.required],
        email: null,
        phoneNumber: null,
        id: null
      })
    );
  }

  submitAll() {
    if (this.contactForms.length == 0) {
      return;
    }
    for (let contactForm of this.contactForms) {
      if (contactForm.invalid) {
        this.toastService.addError("Error", "Please complete all required fields");
        return;
      }
    }
    for (let contactForm of this.contactForms) {
      if (contactForm.value.id == null) {
        let contact = new SchoolContact(
          contactForm.value.contactType,
          contactForm.value.name,
          contactForm.value.email,
          contactForm.value.phoneNumber
        );
        this.httpService.postSchoolContact(contact, this.schoolService.selectedSchoolId).subscribe(res => {
          contactForm.get("id")!.setValue(res);
          this.toastService.addSuccess("Success", "contact created");
          console.log("success");
        });
      } else {
        let contact = new SchoolContact(
          contactForm.value.contactType,
          contactForm.value.name,
          contactForm.value.email,
          contactForm.value.phoneNumber,
          null,
          null,
          null,
          null,
          contactForm.value.id
        );
        this.httpService.putSchoolContact(contact).subscribe(() => {
          console.log("update success");
        });
      }
    }
  }

  deleteContact(selectedForm: FormGroup) {
    if (selectedForm.value.id) {
      this.httpService.deleteSchoolContact(selectedForm.value.id).subscribe(() => {
        console.log("success");
        this.removeItem(selectedForm);
      });
    } else {
      this.removeItem(selectedForm);
    }
  }

  removeItem(form: FormGroup) {
    for (let i = 0; i < this.contactForms.length; i++) {
      if (this.contactForms[i] == form) {
        this.contactForms.splice(i, 1);
      }
    }
  }

}